import { useEffect, useState } from 'react';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import AuthenticatorIntroduction from './AuthenticatorIntroduction';
import AuthenticatorSetup from './AuthenticatorSetup';
import AuthenticatorSummary from './AuthenticatorSummary';

const UserSelfAuthenticatorSettings = () => {
    const { isAuthenticatorEnabled } = useAccount();

    const [step, setStep] = useState(isAuthenticatorEnabled ? 'summary' : 'introduction');

    useEffect(() => {
        // handle issues where we are not back to introduction
        if (step === 'summary' && !isAuthenticatorEnabled) {
            setStep('introduction');
        }

        // similar, but going back to summary
        if (step !== 'summary' && isAuthenticatorEnabled) {
            setStep('summary');
        }
    }, [isAuthenticatorEnabled, step, setStep]);

    switch (step) {
        case 'introduction':
            return <AuthenticatorIntroduction next={() => setStep('setup')} />;

        case 'setup':
            return <AuthenticatorSetup next={() => setStep('summary')} previous={() => setStep('introduction')} />;

        case 'summary':
            return <AuthenticatorSummary />;

        default:
            return null;
    }
};

export default UserSelfAuthenticatorSettings;
